<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="areas" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Áreas</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                v-on="on"
                @click="export_excel(areas)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    @click="estado='novo'"
                    fab
                    dark
                    small
                    class="plus-btn mb-2"
                    v-on="on"
                  >
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.g_area_id" label="Glintt Área ID"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.name" label="Nome Área"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field v-model="editedItem.title" label="Título"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea v-model="editedItem.description" label="Descrição"></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <!-- <v-text-field v-model="editedItem.color_code" label="Cor da Área"></v-text-field> -->
                          <small>Cor da Área</small>
                          <v-color-picker v-model="editedItem.color_code" mode="hexa" label="Cor da Área"></v-color-picker>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{areaMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed class="mr-2" fab dark color="#90A99C" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "areas",
  data: () => ({
    search: '',
    estado: "",
    areaMsg: "",
    dialog: false,
    headers: [
      { text: "ID",  align: "start", value: "id", sortable: true },
      { text: "Glintt Área ID", sortable: true, value: "g_area_id" },
      { text: "Nome", sortable: true, value: "name" },
      { text: "Descrição", sortable: false, value: "description" },
      { text: "Acções",  align: "end", value: "actions", sortable: false }
    ],
    areas: [],
    editedIndex: -1,
    editedItem: {
      name: ""
    },
    defaultItem: {},
    createResult: {},
    updateResult: {}
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Área" : "Editar Área";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this,close()
        this.areaMsg = ""
        this.editedItem = {}
        this.editedIndex = -1

      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'areas-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch("collectAreas", this);
    },

    editItem(item) {
      this.editedIndex = this.areas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = "editar";
    },

    async deleteItem(item) {
      if (!confirm("Tem a certeza que quer eliminar esta Área?")){
        return
      }
      this.editedIndex = this.areas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.status = 0;
      await this.$store.dispatch("deleteArea", this);
      this.initialize();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.areaMsg = "A validar...";
      if (this.estado == "novo") {
        if (this.editedItem.name == "") {
          this.areaMsg = "Introduza o nome da Área a criar";
        } 
        else if (this.editedItem.title == "") {
          this.areaMsg = "Introduza o titulo da Área a criar";
        }
        else if (this.editedItem.description == "") {
          this.areaMsg = "Introduza a descrição da Área a criar";
        }
        else if (this.editedItem.g_area_id == "") {
          this.areaMsg = "Introduza o ID interno da Área a criar";
        }
        else if (this.editedItem.color_code == "") {
          this.areaMsg = "Introduza a cor da Área a criar";
        }
        else {
          await this.$store.dispatch("createArea", this);
        }
      } else {
        await this.$store.dispatch("updateArea", this);
      }
    }
  }
};
</script>

